import React from 'react'
import Dashboard from '../dashboard'
import BonusView from './page'

const Bonus = () => {
  return <Dashboard component={<BonusView />} />
}

export default Bonus
